import {Component, OnInit} from '@angular/core';

import {NgEventBus} from 'ng-event-bus';
import {HeaderComponent} from '../templates';
import {FooterComponent} from '../templates';
import {NlrUserAccountDetailsService} from './user-account-details.service';
import {User} from './user-account.model';
import {AuthenticatorService} from '../common/service/authenticator.service';

@Component({
    selector: 'nlr-plan-user-account-details',
    imports: [HeaderComponent, FooterComponent],
    templateUrl: './user-account-details.component.html',
    styleUrl: './user-account-details.component.scss'
})
export class UserAccountDetailsComponent implements OnInit {
    userDetailsViewModel: User;
    title = 'Your account details';

    constructor(
        private authenticatorService: AuthenticatorService,
        private eventBus: NgEventBus,
        private nlrUserAccountDetailsService: NlrUserAccountDetailsService
    ) {}

    ngOnInit(): void {
        this.getUser();
    }

    getUser() {
        const subs = this.nlrUserAccountDetailsService.getUser(this.authenticatorService.getUsername()).subscribe({
            next: data => {
                this.userDetailsViewModel = data;
                console.log(this.title + '- Successfully acquired user certificate information.');
            },
            error: error => {
                console.error(this.title + '- Could not acquire user certificate information: ' + error.message);
            }
        });

        this.eventBus.cast('nlr:busy', subs);
    }

    getUserDisplayName() {
        return this.authenticatorService.getDisplayName();
    }
}
